import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ValidityAdornment from '../ValidityAdornment';
import { useTheme } from '@mui/material/styles';

const EmailContentLabel = ({ title, contentValidity, skipOptoutControl = false }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex' }}>
      <Typography
        style={{
          margin: '5px 10px',
          color: !contentValidity.contentIsValid
            ? theme.palette.error.main
            : theme.palette.text.secondary,
        }}
        variant="subtitle2"
        noWrap
      >
        {title}
      </Typography>
      <ValidityAdornment
        valid={contentValidity.contentIsValid}
        message={
          !contentValidity.contentIsValid
            ? contentValidity.invalidities.content.map(msg => (
                <ul key={msg}>
                  <li>{msg}</li>
                </ul>
              ))
            : ''
        }
      />
      {!skipOptoutControl && !contentValidity.hasOptoutLink && (
        <ValidityAdornment
          valid={false}
          message={
            <ul>
              <li>{t('smartmessaging.contentEditor.mail.optoutLinkMissing')}</li>
            </ul>
          }
        />
      )}
    </div>
  );
};

EmailContentLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  skipOptoutControl: PropTypes.bool,
};
EmailContentLabel.defaultProps = {
  skipOptoutControl: false,
};

export default EmailContentLabel;
